import React from 'react';
import { Button } from '@material-ui/core';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import CustomToolTip from '../../common/CustomToolTip';

let toolTip = 'click to download this file';
// download URL button to download built file with a single click from GCS.
const DownloadUrl = ({ downloadUrl, isBtnDisabled, toolTipMsg, label }) => {
	if (toolTipMsg.length > 0) {
		toolTip = toolTipMsg;
	}
	return (
		<div data-cy="download-url-btn">
			<CustomToolTip
				title={toolTip}
				InnerComponent={
					<Button
						startIcon={<CloudDownloadOutlinedIcon />}
						size="large"
						href={downloadUrl}
						color="primary"
						disabled={isBtnDisabled}
					>
						<span style={{textTransform:'uppercase'}}>{label}</span>
					</Button>
				}
			></CustomToolTip>
		</div>
	);
};

export default DownloadUrl;
